module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/adondevivir_mobile.bfd86df4.svg";